export default {
  why: {
    heroTitlePre: 'Infoware S. A.:',
    heroTitleExpert: 'Experts',
    heroTitleMid: 'in organizing your',
    heroTitleHighlight: 'processes and technologies',
    heroSubtitle: 'We become a strategic partner for our clients.',
    missionTitle: 'Mission',
    missionText: 'To help Latin American organizations improve their administrative processes through the effective use of information technology.',
    visionTitle: 'Vision',
    visionText: 'To be a collaborative technology platform that allows organizations to improve their processes and make them more effective by incorporating human resources and specialized companies as agents.',
    cred1Value: '20+',
    cred1Text: 'Years innovating in Latin America',
    cred2Value: 'Carbon Neutral',
    cred2Text: 'Carbon Neutral Certified',
    cred3Value: 'ISO 27001',
    cred3Text: 'ISO 27001 Certified',
    expertiseTitle: 'Our technology expertise',
    card1H4a: 'Interface design',
    card1Pa: 'Interface design for almost all applications.',
    card1H4b: 'Digital ecosystem development',
    card1Pb: 'To optimize application interoperability.',
    card2H4a: 'Integration development',
    card2Pa: 'With teams from IBM, UNISYS, ORACLE and SyBase.',
    card2H4b: 'Combination of technologies and techniques',
    card2Pb: 'HTML, PHP, XML, XSLT, JavaScript, AJAX, .NET, NodeJS, C++.',
    card3H4a: 'Technology infrastructure',
    card3Pa: 'For distribution networks of electronic products.',
    card3H4b: 'Internet Banking and Software',
    card3Pb: 'B2B, B2P, P2P.',
    card4H4a: 'Robotization, emulation and intermediation',
    card4Pa: 'Between technologies.',
    card4H4b: 'Migrations, optimization, integration and resolution',
    card4Pb: 'Of multiple applications and problems.',
    clientsTitle: 'Find us in',
    clientsSubtitle: 'Costa Rica, El Salvador, Colombia and Peru',
    clientsDesc: 'Governments, financial institutions, industries and services.',
    dotLabel: 'Go to slide',
    supportImageAlt: 'Infoware S. A. support and continuous improvement center',
    supportTitlePre: 'Support center',
    supportTitlePost: 'and continuous improvement',
    supportPriority: 'Our priority is to listen to you.',
    supportIntro: 'In our portal you will be able to:',
    supportItem0: 'Submit tickets about problems or issues you find.',
    supportItem1: 'Track the tickets you have submitted.',
    supportItem2: 'Review tickets submitted by your institution.',
    supportItem3: 'Learn from our knowledge base.',
    supportItem4: 'Access our customer community.',
    supportItem5: 'Find and share solutions through our forum.',
    supportButton: 'Go to the support center!',
    saasTitle: 'SaaS Service',
    saasIntroPre: 'Say',
    saasIntroHighlight: 'goodbye',
    saasIntroPost: 'to hardware, licensing and application administration problems.',
    saasGrid0: 'Hardware and software platform aimed at clients who require a comprehensive solution for their management work, providing a secure site with the appropriate software and hardware resources.',
    saasGrid1: 'Platform with 3 clustered servers, each with 3 terabytes in md-RAD1, 64GB RAM and 6 processors at 3.2MHz.',
    saasGrid2: 'Server architecture that guarantees reliability, load balancing and Internet Banking level security.',
    availabilityTitlePre: 'Availability over',
    availabilityHighlight: '99%',
    availabilityTitlePost: 'of the time',
    availabilityTextPre: 'To protect your valuable information, Infoware S. A. is responsible for the administration of servers and databases, but has no knowledge of the user credentials to access the application. The administration of',
    availabilityTextHighlight: 'security',
    availabilityTextPost: 'is the task of the administrator designated by the client.',
    availCard0: 'Support and continuous improvement forum.',
    availCard1: 'GPAX updates application.',
    availCard2: 'Online support chat.',
    availCard3: 'Replicas in different countries.',
    ctaTitle: 'Want to know more about us?',
    ctaButton: 'Contact us',
  },
};